import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9138b3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pic" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt" }
const _hoisted_4 = { class: "title nowrap" }
const _hoisted_5 = { class: "attr" }
const _hoisted_6 = { class: "clicknum" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yanjing_xianshi" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_link, {
      to: { name: 'free-goods', params: { id: _ctx.goods.id } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.goods.old_avatar
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.goods.name), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.goods.desc), 1)
        ]),
        _createElementVNode("p", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.goods.browse) + "次浏览 ", 1)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}